/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
    }

    connectedCallback() {
      const lastElement = document.querySelector('.swiper-wrapper');
      if (lastElement) {
        this.lastElementPosition = lastElement.getBoundingClientRect().top + window.scrollY - this.pageHeight;
      } else {
        this.lastElementPosition = this.pageHeight;
      }

      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.checkVisible.bind(this));
    }

    checkVisible(event) {
      window.requestAnimationFrame(() => {
        let y = window.scrollY;
        if (y > this.pageHeight && y > this.lastElementPosition) {
          this.classList.add('back-to-top--active');
        } else {
          this.classList.remove('back-to-top--active');
        }
      });
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
  customElements.define('back-to-top', BackToTop);
}